import { useCallback, useRef } from "react";
import { useAppDispatch } from "../../../../services/redux/hooks/use-dispatch";
import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import { TEntityInfo } from "../../../../common/types/utility";
import { selectAppPopovers } from "../selectors";
import { TPopoverIds } from "../types";
import { updatePopover } from "../slice";

export const useAppPopovers = () => {
  const dispatch = useAppDispatch();
  const appPopovers = useAppSelector(selectAppPopovers);
  const anchorRef = useRef<HTMLElement | null>(null);
  const openPopoverId = useRef<TPopoverIds | null>(null);

  const handleOpenPopover = useCallback(
    (
      event: React.MouseEvent,
      popoverId: TPopoverIds,
      info: TEntityInfo | null,
      subtype?: string,
    ) => {
      const button = event.currentTarget as HTMLElement;
      anchorRef.current = button;
      openPopoverId.current = popoverId;

      const rect = button.getBoundingClientRect();
      dispatch(
        updatePopover({
          id: popoverId,
          info: info,
          isOpen: true,
          position: { x: rect.x, y: rect.y },
          subtype,
        }),
      );
    },
    [dispatch],
  );

  const handleClosePopover = useCallback(
    (popoverId: TPopoverIds, subtype?: string) => {
      dispatch(
        updatePopover({
          id: popoverId,
          info: null,
          isOpen: false,
          subtype: subtype,
          position: null,
        }),
      );
    },
    [dispatch],
  );

  return {
    appPopovers,
    handleOpenPopover,
    handleClosePopover,
  };
};
